import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import axios from 'axios';
import axiosInstance from '../services/AxiosInstance';
import InputField from './InputField';
import Pagigination from './Pagination';
import ExcelImport from './ExcelImport';
import { Link } from 'react-router-dom';
import Loader from "react-js-loader";


const AdminDataTable = ({
    url,
    column,
    header = [],
    title = '',
    excelheader,
    excelurl,
    filename,
}) => {

    const [delIds, setDelIds] = useState([]);
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [input, setInput] = useState();
    const [excelImport, setexcelImport] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ "show": false, "msg": "" });

    let cancelToken;

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = (page = 1) => {
        setLoader(true);
        axiosInstance(`${url}?page=${page}`, { method: 'GET' })
            .then(res => { setData(res.data) })
            .catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
            .finally(() => setLoader(false));
    }

    const handleSubmit = () => {
        var lurl = input?.id ? `${url}/${input?.id}/` : url;
        var method = input?.id ? "PUT" : "POST";
        axiosInstance(lurl, { method: method, data: { "name": input.name } }).then(res => {
            if (res.status === 201 || res.status === 200) {
                setInput();
                getData();
                setAlertMessage({ "show": true, "msg": input?.id ? "Updated" : "Added" })
                document.getElementById("inp").focus();
                setTimeout(() => { setAlertMessage({ "show": false }) }, 3000);
            }
        }).catch(err => {
            err?.response?.data && swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", })
        });
    }

    const handleSelect = (e, id, name) => {
        if (e.target.checked) {
            setDelIds(delIds => [...delIds, id]);
        } else {
            setDelIds(delIds => delIds.filter(item => item !== id));
        }
        if (name) {
            if (e.target.checked) {
                let ids = [];
                for (let index = 0; index < data?.results?.length; index++) {
                    ids.push(data?.results?.[index]?.id);
                }
                setDelIds(ids);
            } else setDelIds([]);
        }
    }

    const handleDelete = () => {
        swal({
            text: "Are you sure that you want to delete this record?",
            icon: "warning",
            dangerMode: true,
        }).then(willDelete => {
            if (willDelete) {
                axiosInstance(`${url}/?delete_ids=${delIds.join(",")}`, { method: "DELETE" })
                    .then(res => {
                        if (res?.status === 204) {
                            getData();
                            setDelIds([]);
                            swal("", "Deleted Successfully", "success", { button: "Ok!", })
                        }
                    })
                    .catch(err => swal("", err?.response?.data?.detail, { button: "Ok!", }))
            }
        });
    }

    const handleCloseExport = () => {
        setexcelImport(!excelImport);
        getData();
    }

    const handleSearchChange = async e => {
        // Function to cancel previous request on searching for api optimization
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        try {
            await axiosInstance(
                `${url}?&search=${e.target.value}`,
                {
                    method: "GET",
                    cancelToken: cancelToken.token
                }).then(res => {
                    setData(res?.data)
                })
        } finally {
            return data
        }
    }

    if (loader) {
        return <Loader
            type="spinner-cub"
            bgColor={"#2e55fa"}
            title={"bubble-top"}
            color={'#FFFFFF'}
            size={100}
        />
    }

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white p-b20">
                    <div className="container">
                        <div className="job-bx browse-job clearfix">
                            <div className="job-bx-title  clearfix">
                                <h5 className="font-weight-700 pull-left text-uppercase">{title}</h5>
                                {
                                    delIds.length > 0 &&
                                    <div className="float-right">
                                        <button
                                            className="site-button btn-sm btn-danger ml-3"
                                            onClick={handleDelete}
                                            title="Click here to delete the records"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                }
                                <div className="float-right">
                                    {
                                        excelheader?.length > 0 &&
                                        <span
                                            className="float-right mt-1 pointer text-primary"
                                            onClick={() => handleCloseExport()}
                                            style={{ fontSize: "18px" }}
                                        >
                                            {excelImport ?
                                                <Link to="#" className="site-button right-arrow button-sm float-right">Back</Link>
                                                : <i className="fa fa-upload"> Import</i>}
                                        </span>
                                    }
                                </div>
                            </div>
                            {
                                excelImport ?
                                    <ExcelImport
                                        headers={excelheader}
                                        url={excelurl}
                                        filename={filename}
                                        handleCloseExport={handleCloseExport}
                                    /> :
                                    <>
                                        <InputField
                                            className="small-input w-25 float-right"
                                            placeholder='Search...'
                                            onChange={handleSearchChange}
                                        />
                                        <div className="table-resposive template-table">
                                            <table className="table-job-bx cv-manager company-manage-job">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                id="vehicle1"
                                                                name="vehicle1"
                                                                value="Bike"
                                                                checked={data?.results?.length ? data?.results?.length === delIds?.length : false}
                                                                onChange={(e) => handleSelect(e, 'all', 'all')}
                                                            />
                                                        </th>
                                                        <th className="feature">##</th>
                                                        {
                                                            header?.map(res => {
                                                                return (
                                                                    <th key={res} >{res}</th>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data?.results?.map((res, i) => {
                                                            var id = +`${data?.pagination?.currentPage - 1}0`
                                                            return (
                                                                <tr key={i + 'tr'}>
                                                                    <td width="5%">
                                                                        <input
                                                                            type="checkbox"
                                                                            name={`select${res?.id}`}
                                                                            checked={delIds?.includes(res?.id)}
                                                                            onChange={(e) => handleSelect(e, res.id)}
                                                                        />
                                                                    </td>
                                                                    <td width="10%" key={res.id} className="feature">{id + i + 1}</td>
                                                                    {
                                                                        column.map(col => {
                                                                            let data
                                                                            if (res.id === input?.id) {
                                                                                return <td key={data}>
                                                                                    <InputField
                                                                                        value={input?.name || ''}
                                                                                        className="small-input"
                                                                                        placeholder='Add Record'
                                                                                        onChange={(e) => setInput({ ...input, "name": e.target.value })}
                                                                                    />
                                                                                </td>
                                                                            }
                                                                            if (Array.isArray(col))
                                                                                data = res[col[0]][col[1]]
                                                                            else
                                                                                data = res[col]
                                                                            return <td key={data} style={{ whiteSpace: "pre" }}>{data}</td>
                                                                        })
                                                                    }
                                                                    <td key="addtdel" className="job-links text-center">
                                                                        <span>
                                                                            {
                                                                                res.id === input?.id ?
                                                                                    <>
                                                                                        <button
                                                                                            className="btn btn-sm btn-primary"
                                                                                            title='Click here to update the record'
                                                                                            onClick={handleSubmit}
                                                                                        >
                                                                                            Update
                                                                                        </button>
                                                                                        <button
                                                                                            className="btn btn-sm btn-danger ml-1"
                                                                                            title='Click here to update the record'
                                                                                            onClick={() => setInput()}
                                                                                        >
                                                                                            Discard
                                                                                        </button>
                                                                                    </>
                                                                                    :
                                                                                    <i className="ti-pencil" title="Click here to edit the record" style={{ cursor: "pointer" }} onClick={() => setInput({ ...res, "edit": true })} />
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    <td colSpan="3">
                                                        {alertMessage.show &&
                                                            <span className="text-danger font-weight-bold">The record is {alertMessage.msg} successfully!</span>
                                                        }
                                                    </td>
                                                    <tr key="addtsinglelineadd">
                                                        <td key="addtin" colSpan={header?.length + 1}>
                                                            <InputField
                                                                value={!input?.id ? (input?.name || '') : ''}
                                                                className="small-input"
                                                                placeholder='Add Record'
                                                                onChange={(e) => setInput({ ...input, "name": e.target.value })}
                                                                id="inp"
                                                            />
                                                        </td>
                                                        <td key="addtadd">
                                                            <button
                                                                className={`btn btn-sm btn-primary ${!input?.name?.length && "custom-disabled"}`}
                                                                title={`Click here to add the record`}
                                                                onClick={handleSubmit}
                                                            >
                                                                Add
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagigination
                                            data={data}
                                            getData={getData}
                                        />
                                    </>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminDataTable;